import { render, staticRenderFns } from "./variable.vue?vue&type=template&id=a8430f56&lang=pug&"
import script from "./variable.vue?vue&type=script&lang=ts&"
export * from "./variable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports